import React from "react";
import TasksBoard from "../components/TasksBoard";
import { Card } from "../components/ui/card";
import { CheckSquare } from "lucide-react";

export default function TasksPage() {
  return (
    <div className="space-y-6" data-testid="tasks-page">
      <header>
        <div className="flex items-center gap-2">
          <CheckSquare className="w-5 h-5 text-primary" />
          <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight">Attività</h1>
        </div>
        <p className="text-muted-foreground text-sm mt-1">Gestisci tutte le attività operative in un unico posto.</p>
      </header>
      <Card className="border-border/60 p-6">
        <TasksBoard />
      </Card>
    </div>
  );
}
